import { useState, useEffect, useCallback } from 'react';
import usePageSize from 'Hooks/usePageSize';
import useDebounce from 'Hooks/useDebounce';
import fetchCoursesForAssignment from 'Api/coursesForAssignment';
import jobTitlesApi from 'Api/axios/job-titles-api';

const useCourseAssignment = () => {
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSizeState] = usePageSize('selectCoursesDialog', 10);

  // La página de este catálogo va base cero. Cambiar el tamaño vuelve al
  // inicio: quien estaba en la 7 con 10 por página se saldría al pedir 100.
  const setPageSize = value => {
    setPageSizeState(value);
    setPage(0);
  };
  const [search, setSearch] = useState('');

  const debouncedSearch = useDebounce(search, 500);

  const loadCourses = useCallback(async () => {
    setLoadingCourses(true);
    try {
      const result = await fetchCoursesForAssignment({
        page: page + 1,
        pageSize,
        name: debouncedSearch || undefined,
      });
      setCourses(result.data);
      setPagination(result.pagination);
    } catch (err) {
      console.error('[useCourseAssignment] Failed to fetch courses:', err);
    } finally {
      setLoadingCourses(false);
    }
  }, [page, pageSize, debouncedSearch]);

  useEffect(() => {
    loadCourses();
  }, [loadCourses]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  const assignCourses = async (selectedCourseIds, jobTitleIds) => {
    setAssigning(true);
    try {
      const response = await jobTitlesApi.assignCoursesBulk({
        jobTitleIds,
        courseIds: selectedCourseIds,
      });
      if (response.error) {
        throw new Error(response.error);
      }
      return response.data;
    } finally {
      setAssigning(false);
    }
  };

  return {
    courses,
    loadingCourses,
    assigning,
    assignCourses,
    pagination,
    page,
    pageSize,
    search,
    setPage,
    setPageSize,
    setSearch,
  };
};

export default useCourseAssignment;
